module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","sort":{"old":"Oldest","new":"Newest"}}}')
  delete Component.options._Ctor
}
